// Modal "Préstamo" de los cobros de cuota pagados con conversión (saldo USDT
// o Visa USD). Cada botón .js-loan-payment-info trae en data-loan-payment el
// JSON de Credits::LoanPaymentDetail, ya formateado por el servidor. Todo se
// escribe con textContent: nada del JSON se interpreta como HTML.

// Únicas clases que el JSON puede pedir: las de los decimales más chicos de
// toda la app (base.scss). Cualquier otra se ignora.
const DECIMAL_CLASSES = new Set(['money-decimal-mark', 'money-decimal']);
const CHARGE_FIELDS = new Set(['charged_from_balance', 'charged_from_card']);
const BREAKDOWN_FIELDS = new Set(['concept_amount', 'rate']);
const TERMS_FIELDS = new Set(['term', 'monthly_rate']);

const fillValue = (element, row) => {
  if (!Array.isArray(row.parts) || row.parts.length === 0) {
    element.textContent = row.value;
    return;
  }
  row.parts.forEach((part) => {
    const text = String(part.text ?? '');
    if (DECIMAL_CLASSES.has(part.class)) {
      const span = document.createElement('span');
      span.className = part.class;
      span.textContent = text;
      element.appendChild(span);
    } else {
      element.appendChild(document.createTextNode(text));
    }
  });
};

const readyLoanPaymentModal = () => {
  const modal = document.getElementById('modal-loan-payment');
  if (!modal || modal.dataset.bound === 'true') return;
  modal.dataset.bound = 'true';

  const title = document.getElementById('modal-loan-payment-title');
  const subtitle = document.getElementById('modal-loan-payment-subtitle');
  const charge = document.getElementById('modal-loan-payment-charge');
  const breakdown = document.getElementById('modal-loan-payment-breakdown');
  const rows = document.getElementById('modal-loan-payment-rows');
  const terms = document.getElementById('modal-loan-payment-terms');
  const closer = document.getElementById('modal-loan-payment-close');

  let opener = null;

  // Al cerrar, el foco vuelve a lo que abrió el modal (no cae al body).
  const close = () => {
    modal.style.display = 'none';
    if (opener && typeof opener.focus === 'function') opener.focus();
    opener = null;
  };

  const open = (detail, trigger) => {
    opener = trigger;
    title.textContent = detail.title || '';
    subtitle.textContent = detail.subtitle || '';
    charge.replaceChildren();
    breakdown.replaceChildren();
    rows.replaceChildren();
    terms.replaceChildren();
    (detail.rows || []).forEach((row) => {
      const wrapper = document.createElement('div');
      wrapper.dataset.field = row.key || '';
      const label = document.createElement('dt');
      const value = document.createElement('dd');
      label.textContent = row.label;
      fillValue(value, row);
      wrapper.append(label, value);
      const group = CHARGE_FIELDS.has(row.key) ? charge
        : BREAKDOWN_FIELDS.has(row.key) ? breakdown
        : TERMS_FIELDS.has(row.key) ? terms : rows;
      group.appendChild(wrapper);
    });
    charge.hidden = charge.childElementCount === 0;
    breakdown.hidden = breakdown.childElementCount === 0;
    terms.hidden = terms.childElementCount === 0;
    modal.style.display = 'flex';
    if (closer) closer.focus();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.js-loan-payment-info');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    try {
      open(JSON.parse(button.dataset.loanPayment), button);
    } catch (_error) {
      // Un JSON roto no debe romper la página: simplemente no se abre.
    }
  });

  if (closer) closer.addEventListener('click', close);
  modal.addEventListener('click', (event) => {
    if (event.target === modal) close();
  });
  document.addEventListener('keydown', (event) => {
    if (modal.style.display === 'none') return;
    if (event.key === 'Escape') close();
    // El modal tiene un solo control: el foco no se escapa a la página de atrás.
    if (event.key === 'Tab' && closer) {
      event.preventDefault();
      closer.focus();
    }
  });
};

export default readyLoanPaymentModal;
